module.exports = __webpack_public_path__ + "apple-touch-icon-152x152.png?2c089ee1dd4a1a1280e5dd18bd25be27";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-touch-icon-152x152.png
// module id = 141
// module chunks = 0